module.exports = __webpack_public_path__ + "img/loto-4-59-mobile.da3d2dd2.png";